import React from 'react';
import PropTypes from 'prop-types';
import { addModifier } from '../helpers';

const EcommerceButton = ({ handleOnClick, buttonText, className, modifier, isDisabled }) => {
  const buttonClassName = `${className}__button`;
  const classNameWithModifier = addModifier(buttonClassName, modifier);

  return (
    <button
      type="button"
      className={classNameWithModifier}
      onClick={handleOnClick}
      disabled={isDisabled}>
      <span className={`${className}__button___text`}>{buttonText}</span>
    </button>
  );
};

EcommerceButton.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  isDisabled: PropTypes.bool
};

EcommerceButton.defaultProps = { modifier: '', isDisabled: false };

export default EcommerceButton;
